import {
  RESET_COLUMN_FILTERS,
  SET_COLUMN_FILTER,
  TRIGGER_FILTERS,
} from '../constants';

const initial = {
  filterApplied: true,
  totalHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'totalHours',
  },
  expectedHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'expectedHours',
  },
  totalWfhHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'totalWfhHours',
  },
  totalExternalHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'totalExternalHours',
  },
  totalOfficeHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'totalOfficeHours',
  },
  weekendHours: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'weekendHours',
  },
  workFromHomeDays: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'workFromHomeDays',
  },
  deficitHrs: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'deficitHrs',
  },
  leaves: {
    type: 'NUMBER',
    value: '',
    argument: '',
    field: 'leaves',
  },
};

export default (state = initial, event) => {
  switch (event.type) {
    case SET_COLUMN_FILTER:
      return {
        ...state,
        [event.data.field]: {
          type: 'NUMBER',
          value: event.data.value,
          argument: event.data.argument,
          field: event.data.field,
        },
      };
    case RESET_COLUMN_FILTERS:
      return initial;
    case TRIGGER_FILTERS:
      return {
        ...state,
        filterApplied: !state.filterApplied,
      };
    default:
      return state;
  }
};
